module.exports = __webpack_public_path__ + "static/bg-068812c9dc2766e0cdd38c0820aa9c34.jpg";